var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.seen)?_c('div',{staticClass:"screen"},[_c('img',{attrs:{"src":require("@/assets/logo-white.svg"),"width":"250","height":"50"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }